// extracted by mini-css-extract-plugin
module.exports = {"createDialog":"createDialog--1gG9O","more":"more--_77Ez","switchLabel":"switchLabel--2LtsD","check":"check--1EtjQ"};